// (bnikom) code based off of https://github.com/emilebres/react-virtualized-checkbox

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AutoSizer from 'react-virtualized-auto-sizer';

import Checkboxes from './Checkboxes';

class VirtualizedCheckbox extends Component {
  constructor(props) {
    super(props);

    this.state = {
      items: [],
    };
  }

  static getDerivedStateFromProps(props, state) {
    if (props.items.length !== state.items.length) {
      return {
        items: props.items,
      };
    }
    return null;
  }

  handleChange = eventTarget => {
    const { labelKey, selectCoverPhoto } = this.props;

    const items = [...this.state.items];

    // (bnikom) find index of selected item
    const itemIndex = this.state.items.findIndex(
      item => item[labelKey] === eventTarget[labelKey]
    );

    // update new list with changed check, only itemIndex should
    const updatedItems = items.map((item, index) => {
      (index === itemIndex) ? item.checked = eventTarget.checked : item.checked = false;
      return item;
    });

    this.setState({ items: updatedItems });

    if (selectCoverPhoto) {
      selectCoverPhoto(items[itemIndex]);
    }
  };

  render() {
    const {
      columnCount,
      columnWidth,
      rowHeight,
      width,
    } = this.props;

    return (
      <AutoSizer disableWidth>
        {({ height }) => (
          <Checkboxes
            columnCount={columnCount}
            columnWidth={columnWidth}
            height={height}
            width={width}
            items={this.state.items}
            labelKey={this.props.labelKey}
            rowHeight={rowHeight}
            onChange={this.handleChange}
          />
        )}
      </AutoSizer>
    );
  }
}

VirtualizedCheckbox.propTypes = {
  items: PropTypes.array,
  labelKey: PropTypes.string,
  selectCoverPhoto: PropTypes.func,
};

VirtualizedCheckbox.defaultProps = {
  labelKey: 'label',
  selectCoverPhoto: () => null,
  items: [],
};

export default VirtualizedCheckbox;
